
import apiClient from "../../core/apiClient";
import { Family, FamilyMember } from "../../interfaces/DTO/crm/family";
import { BaseService } from "../BaseService";

const API_URL = "/family-members";

class FamilyMemberService extends BaseService<FamilyMember> {
  constructor() {
    super(API_URL);
  }

  async fetchFamilyMembersByFamily(familyId: number): Promise<FamilyMember[]> {
    if (familyId === 0) return [];
    const response = await apiClient.get<FamilyMember[]>(`${this.baseUrl}/family/${familyId}`);
    return response.data;
  }

  async fetchFamiliesByContact(contactId: number): Promise<Family[]> {
    if (contactId === 0) return [];
    const response = await apiClient.get<Family[]>(`${this.baseUrl}/user/${contactId}/families`);
    return response.data;
  }

  async fetchFamilyMemberByContactAndFamily(userId: number, familyId: number): Promise<FamilyMember> {
    if (userId === 0 && familyId === 0) return {} as FamilyMember;
    const response = await apiClient.get<FamilyMember>(`${this.baseUrl}/user/${userId}/family/${familyId}`);
    return response.data;
  }
}

export const familyMemberService = new FamilyMemberService();